import overviewReducer from './InvoicesReducer';
import detailReducer from './InvoiceReducer';
import detailDocumentsReducer from './InvoiceDocumentsReducer';
import detailLinesReducer from './InvoiceLinesByInvoiceIdReducer';
import { combineReducers } from '@reduxjs/toolkit';

export const invoicesDataReducers = combineReducers({
	overview: overviewReducer,
	detail: detailReducer,
	detail_documents: detailDocumentsReducer,
	detail_lines: detailLinesReducer
});